import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/esnext.map.delete-all.js";
import "core-js/modules/esnext.map.every.js";
import "core-js/modules/esnext.map.filter.js";
import "core-js/modules/esnext.map.find.js";
import "core-js/modules/esnext.map.find-key.js";
import "core-js/modules/esnext.map.includes.js";
import "core-js/modules/esnext.map.key-of.js";
import "core-js/modules/esnext.map.map-keys.js";
import "core-js/modules/esnext.map.map-values.js";
import "core-js/modules/esnext.map.merge.js";
import "core-js/modules/esnext.map.reduce.js";
import "core-js/modules/esnext.map.some.js";
import "core-js/modules/esnext.map.update.js";
import "core-js/modules/esnext.set.add-all.js";
import "core-js/modules/esnext.set.delete-all.js";
import "core-js/modules/esnext.set.difference.js";
import "core-js/modules/esnext.set.every.js";
import "core-js/modules/esnext.set.filter.js";
import "core-js/modules/esnext.set.find.js";
import "core-js/modules/esnext.set.intersection.js";
import "core-js/modules/esnext.set.is-disjoint-from.js";
import "core-js/modules/esnext.set.is-subset-of.js";
import "core-js/modules/esnext.set.is-superset-of.js";
import "core-js/modules/esnext.set.join.js";
import "core-js/modules/esnext.set.map.js";
import "core-js/modules/esnext.set.reduce.js";
import "core-js/modules/esnext.set.some.js";
import "core-js/modules/esnext.set.symmetric-difference.js";
import "core-js/modules/esnext.set.union.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import { useShowDebugging } from '~/functions/accounts';
import { TypeMetricAssignedTo, useGetAccountQuery, useListMetricsQuery, useListMetricAssignmentsQuery, useListSectionsQuery, useListCategoriesQuery } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'Metrics',
  props: {
    preSelectedMetrics: {
      default: function _default() {
        return [];
      }
    },
    managedMetricIds: {
      default: function _default() {
        return [];
      }
    },
    height: {
      default: 'calc(100vh - 320px)'
    },
    allowEdit: {
      type: Boolean,
      default: false
    },
    allowCustom: {
      type: Boolean,
      default: true
    },
    showFilters: {
      type: Boolean,
      default: true
    },
    showSelected: {
      type: Boolean,
      default: true
    },
    showAction: {
      type: Boolean,
      default: true
    },
    showAssignedTo: {
      type: Boolean,
      default: true
    },
    showSelect: {
      type: Boolean,
      default: true
    },
    showUnlink: {
      type: Boolean,
      default: false
    },
    columnPreset: {
      default: 'default'
    },
    noDataInfoKey: {
      default: 'enableIndicator'
    },
    query: {
      default: function _default() {
        return {
          text: '',
          sections: [90, 117, 967, 989, 998]
        };
      }
    },
    useAllSections: {
      type: Boolean,
      default: false
    },
    scopedAssigneeIds: {
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup(__props, _ref) {
    var _props$query, _props$query2, _props$query3, _props$query4, _props$query5, _props$query6, _ref3, _props$query7, _props$query8;
    var emit = _ref.emit;
    var props = __props;
    var _ref2 = getCurrentInstance(),
      proxy = _ref2.proxy;

    // Props

    var options = ref({
      page: 1,
      itemsPerPage: 15,
      sortBy: ['name'],
      sortDesc: [false]
    });

    // Helper to normalize arrays (filter empty strings, null, undefined)
    var normalizeArray = function normalizeArray(arr) {
      if (!arr) return [];
      return arr.filter(function (item) {
        return item !== null && item !== '' && item !== undefined;
      });
    };
    var defaultAssignedTos = [TypeMetricAssignedTo.FundMgmt, TypeMetricAssignedTo.FundCompany, TypeMetricAssignedTo.Company, TypeMetricAssignedTo.Fund, null];
    var defaultCategoryIds = [100, 2, 3, 4, 5, 6, 7, 9, 10, 11, 12, 13, 29, 15, 16, 17, 18, 19, 20, 21, 23, 24, 25, 28, 27];
    var HIDDEN_SECTION_IDS = [1801];
    var explicitSectionFilter = normalizeArray(((_props$query = props.query) === null || _props$query === void 0 ? void 0 : _props$query.sections) || []);
    var hasExplicitSectionFilter = explicitSectionFilter.length > 0;
    var isRelationshipQuery = normalizeArray((_props$query2 = props.query) === null || _props$query2 === void 0 ? void 0 : _props$query2.parentIds).length > 0 || normalizeArray((_props$query3 = props.query) === null || _props$query3 === void 0 ? void 0 : _props$query3.childIds).length > 0 || normalizeArray((_props$query4 = props.query) === null || _props$query4 === void 0 ? void 0 : _props$query4.dependencyTypes).length > 0 || Boolean((_props$query5 = props.query) === null || _props$query5 === void 0 ? void 0 : _props$query5.directOnly);
    var isHiddenSection = function isHiddenSection(item) {
      return HIDDEN_SECTION_IDS.includes(Number(item === null || item === void 0 ? void 0 : item.id));
    };
    var input = ref(_objectSpread(_objectSpread({}, props.query), {}, {
      // For relationship lookups (parent/child dependency tables), do not apply
      // the global default category/assigned filters; they can hide valid linked KPIs.
      sections: props.useAllSections ? undefined : hasExplicitSectionFilter ? [-1].concat(_toConsumableArray(explicitSectionFilter)) // default includes Other(id=-1) for scoped flows
      : [],
      // no default section filter for Additional KPIs; keep datapoints discoverable
      assignedTos: isRelationshipQuery ? (_props$query6 = props.query) === null || _props$query6 === void 0 ? void 0 : _props$query6.assignedTos : (_ref3 = (_props$query7 = props.query) === null || _props$query7 === void 0 ? void 0 : _props$query7.assignedTos) !== null && _ref3 !== void 0 ? _ref3 : defaultAssignedTos,
      categoryIds: isRelationshipQuery ? (_props$query8 = props.query) === null || _props$query8 === void 0 ? void 0 : _props$query8.categoryIds : defaultCategoryIds
    }));
    var isPaiSelection = computed(function () {
      var paiSectionIds = [81, 89, 83, 91];
      var sections = input.value.sections || [];
      return paiSectionIds.some(function (id) {
        return sections.includes(id);
      });
    });
    var isAdditionalPaiSelection = computed(function () {
      var additionalPaiSectionIds = [83, 91];
      var sections = input.value.sections || [];
      return additionalPaiSectionIds.some(function (id) {
        return sections.includes(id);
      });
    });
    var paiAssignedToRestriction = computed(function () {
      if (!isPaiSelection.value) return null;
      return isAdditionalPaiSelection.value ? [null] : [TypeMetricAssignedTo.Company, null];
    });
    watch(paiAssignedToRestriction, function (allowedForPai) {
      if (!allowedForPai) {
        return;
      }
      input.value.assignedTos = (input.value.assignedTos || []).filter(function (id) {
        return allowedForPai.includes(id);
      });
    }, {
      immediate: true
    });
    var variables = computed(function () {
      var managedMode = props.columnPreset === 'linked';
      var managedIds = managedMode ? props.managedMetricIds : [];
      var sort = options.value.sortBy.map(function (item, index) {
        return {
          field: item,
          sortDesc: options.value.sortDesc[index]
        };
      });
      var scopedIds = scopedMetricIds.value;
      var scopedInput = scopedIds === null ? {} : scopedIds.length > 0 ? {
        ids: scopedIds
      } : {
        ids: [-1]
      };
      return {
        offset: managedMode ? 0 : options.value.itemsPerPage * (options.value.page - 1),
        limit: managedMode ? managedIds.length : options.value.itemsPerPage,
        input: managedMode ? {
          ids: managedIds,
          text: '',
          sort: sort
        } : _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, input.value), scopedInput), props.useAllSections ? {
          sections: undefined
        } : {}), {}, {
          sort: sort
        })
      };
    });
    var scopedAssigneeIds = computed(function () {
      return (props.scopedAssigneeIds || []).filter(Boolean);
    });
    var _useListMetricAssignm = useListMetricAssignmentsQuery(computed(function () {
        return {
          assigneeIds: scopedAssigneeIds.value,
          limit: -1,
          offset: 0
        };
      }), function () {
        return {
          enabled: scopedAssigneeIds.value.length > 0,
          fetchPolicy: 'cache-and-network'
        };
      }),
      scopedAssignmentsResult = _useListMetricAssignm.result;
    var scopedMetricIds = computed(function () {
      var _scopedAssignmentsRes, _scopedAssignmentsRes2;
      if (!scopedAssigneeIds.value.length) {
        return null;
      }
      var ids = new Set();
      var _iterator = _createForOfIteratorHelper((_scopedAssignmentsRes = (_scopedAssignmentsRes2 = scopedAssignmentsResult.value) === null || _scopedAssignmentsRes2 === void 0 ? void 0 : _scopedAssignmentsRes2.listMetricAssignments) !== null && _scopedAssignmentsRes !== void 0 ? _scopedAssignmentsRes : []),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _row$metric;
          var row = _step.value;
          var metricId = (_row$metric = row.metric) === null || _row$metric === void 0 ? void 0 : _row$metric.id;
          if (metricId != null) {
            ids.add(Number(metricId));
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return Array.from(ids);
    });
    var _useGetAccountQuery = useGetAccountQuery(),
      accountResult = _useGetAccountQuery.result;
    var account = computed(function () {
      var _accountResult$value;
      return ((_accountResult$value = accountResult.value) === null || _accountResult$value === void 0 ? void 0 : _accountResult$value.getAccount) || {
        id: ''
      };
    });
    var sectionVariables = computed(function () {
      return {
        filters: hasExplicitSectionFilter ? {
          ids: explicitSectionFilter,
          text: ''
        } : {
          text: '',
          linkedToMetrics: true,
          parentIsNull: true
        }
      };
    });
    var _useListSectionsQuery = useListSectionsQuery(sectionVariables, {
        enabled: props.showFilters
      }),
      sectionResult = _useListSectionsQuery.result,
      onResult = _useListSectionsQuery.onResult;
    function findLeaves(section) {
      if (!section.sections || !section.sections.length) return [section.id];
      return section.sections.flatMap(function (subsection) {
        return findLeaves(subsection);
      });
    }
    // Merge found leaf section ids into input.sections, avoiding duplicates
    onResult(function (result) {
      var _result$data;
      if (props.useAllSections) {
        return;
      }
      // Only auto-select returned indicator set leaves when caller explicitly scoped sections.
      // For Additional KPIs (no explicit section filter), keep tree unselected by default so
      // users can select datapoints without first clearing auto-selected section filters.
      if (!hasExplicitSectionFilter) {
        return;
      }
      var sections = result === null || result === void 0 ? void 0 : (_result$data = result.data) === null || _result$data === void 0 ? void 0 : _result$data.listSections;
      if (sections) {
        var leafIds = sections.flatMap(function (section) {
          return findLeaves(section);
        });
        input.value.sections = _toConsumableArray(new Set([].concat(_toConsumableArray(input.value.sections || []), _toConsumableArray(leafIds))));
      }
    });
    var _useListMetricsQuery = useListMetricsQuery(variables, function () {
        return {
          enabled: (props.columnPreset !== 'linked' || props.managedMetricIds.length > 0) && (scopedMetricIds.value === null || scopedAssigneeIds.value.length > 0),
          fetchPolicy: 'cache-and-network'
        };
      }),
      metricsResult = _useListMetricsQuery.result,
      loading = _useListMetricsQuery.loading;
    var open = ref([0]);
    var sectionItems = computed(function () {
      var _sectionResult$value;
      return [{
        active: true,
        id: 0,
        label: '',
        sections: [].concat(_toConsumableArray(((_sectionResult$value = sectionResult.value) === null || _sectionResult$value === void 0 ? void 0 : _sectionResult$value.listSections) || []), _toConsumableArray(props.allowCustom ? [{
          active: true,
          leaf: true,
          description: '',
          label: '',
          id: -1,
          sections: []
        }] : []))
      }];
    });
    var openAssignedTo = ref(['all']);
    var assignedToItems = computed(function () {
      return [{
        active: true,
        id: 'all',
        label: '',
        description: '',
        sections: [{
          active: true,
          leaf: true,
          description: '',
          label: proxy.$t('fundManager'),
          id: TypeMetricAssignedTo.FundMgmt,
          sections: [],
          // When selecting PAIs, only Company and None are allowed; others are disabled.
          disabled: isPaiSelection.value
        }, {
          active: true,
          leaf: true,
          description: '',
          label: proxy.$t('fund'),
          id: TypeMetricAssignedTo.Fund,
          sections: [],
          disabled: isPaiSelection.value
        },
        // {
        //   active: true,
        //   leaf: true,
        //   description: '',
        //   label: proxy.$t('fundCompany'),
        //   id: TypeMetricAssignedTo.FundCompany,
        //   sections: [],
        // },
        {
          active: true,
          leaf: true,
          description: '',
          label: proxy.$t('companies'),
          id: TypeMetricAssignedTo.Company,
          sections: [],
          disabled: isAdditionalPaiSelection.value
        }, {
          active: true,
          leaf: true,
          description: '',
          label: proxy.$t('none'),
          id: null,
          sections: [],
          disabled: false
        }]
      }];
    });
    var _useListCategoriesQue = useListCategoriesQuery({
        input: {
          onlyRootElements: true
        }
      }, {
        enabled: props.showFilters
      }),
      categoryResult = _useListCategoriesQue.result,
      onCategoryResult = _useListCategoriesQue.onResult;
    var openCategories = ref(['all']);
    function findCategoryLeaves(category) {
      if (!category.subcategories || category.subcategories.length === 0) {
        return [category.id];
      }
      return category.subcategories.flatMap(function (subcat) {
        return findCategoryLeaves(subcat);
      });
    }
    onCategoryResult(function (result) {
      var _result$data2;
      var categories = result === null || result === void 0 ? void 0 : (_result$data2 = result.data) === null || _result$data2 === void 0 ? void 0 : _result$data2.listCategories;
      if (categories) {
        var defaultIdsSet = new Set(defaultCategoryIds);
        var allLeafIds = new Set();
        var _extractLeavesFromMatchingCategories = function extractLeavesFromMatchingCategories(cat) {
          if (defaultIdsSet.has(cat.id)) {
            var leaves = findCategoryLeaves(cat);
            leaves.forEach(function (id) {
              return allLeafIds.add(id);
            });
          }
          if (cat.subcategories) {
            cat.subcategories.forEach(_extractLeavesFromMatchingCategories);
          }
        };
        categories.forEach(_extractLeavesFromMatchingCategories);
        if (allLeafIds.size > 0) {
          input.value.categoryIds = Array.from(allLeafIds).sort(function (a, b) {
            return a - b;
          });
        }

        // Ensure categories treeview stays open
        if (!openCategories.value.includes('all')) {
          openCategories.value = ['all'].concat(_toConsumableArray(openCategories.value));
        }
      }
    });
    function transformCategoryToTreeview(category) {
      var _category$subcategori;
      return {
        active: true,
        id: category.id,
        label: category.label,
        description: '',
        leaf: !category.subcategories || category.subcategories.length === 0,
        sections: ((_category$subcategori = category.subcategories) === null || _category$subcategori === void 0 ? void 0 : _category$subcategori.map(function (subcat) {
          return transformCategoryToTreeview(subcat);
        })) || []
      };
    }
    var categoryItems = computed(function () {
      var _categoryResult$value;
      var rootCategories = ((_categoryResult$value = categoryResult.value) === null || _categoryResult$value === void 0 ? void 0 : _categoryResult$value.listCategories) || [];
      var transformedCategories = rootCategories.map(transformCategoryToTreeview);
      return [{
        active: true,
        id: 'all',
        label: '',
        description: '',
        sections: transformedCategories
      }];
    });

    // metrics contains all metrics that are ONLY in the selected sections
    var metrics = computed(function () {
      var _metricsResult$value$, _metricsResult$value;
      var rows = (_metricsResult$value$ = (_metricsResult$value = metricsResult.value) === null || _metricsResult$value === void 0 ? void 0 : _metricsResult$value.listMetrics) !== null && _metricsResult$value$ !== void 0 ? _metricsResult$value$ : [];
      if (props.columnPreset !== 'linked') {
        return rows;
      }
      var indexById = new Map(rows.map(function (row) {
        return [Number(row.id), row];
      }));
      var preSelectedById = new Map((props.preSelectedMetrics || []).map(function (row) {
        return [Number(row.id), row];
      }));
      return (props.managedMetricIds || []).map(function (id) {
        var _indexById$get;
        return (_indexById$get = indexById.get(Number(id))) !== null && _indexById$get !== void 0 ? _indexById$get : preSelectedById.get(Number(id));
      }).filter(Boolean);
    });
    var showDebugging = useShowDebugging();
    var headers = computed(function () {
      if (props.columnPreset === 'linked') {
        var linkedHeaders = [{
          value: 'id',
          sortable: true
        }, {
          value: 'name',
          cellClass: 'font-weight-bold',
          sortable: true
        }, {
          value: 'unitName',
          sortable: true
        }, {
          value: 'assignedTo',
          sortable: false
        }, {
          value: 'indicatorSet',
          sortable: false
        }];
        if (props.showUnlink) {
          linkedHeaders.push({
            value: 'unlink',
            sortable: false,
            align: 'end'
          });
        }
        return linkedHeaders;
      }
      var base = [];
      if (showDebugging.value) {
        base.push({
          value: 'id',
          sortable: true
        });
      }
      base.push.apply(base, [{
        value: 'name',
        cellClass: 'font-weight-bold',
        sortable: true
      }, {
        value: 'unitName',
        sortable: true
      }].concat(_toConsumableArray(props.showAssignedTo ? [{
        value: 'assignedTo',
        sortable: true
      }] : []), [{
        value: 'type'
      }, {
        value: 'taxonomy',
        cellClass: 'overflow-auto'
      }
      // TODO implement external url for metrics
      // { text: 'Actions', value: 'actions' },
      ]));
      if (props.allowEdit && props.allowCustom) {
        base.push({
          value: 'edit'
        });
      }
      return base;
    });
    var localPreSelectedMetrics = ref(_toConsumableArray(props.preSelectedMetrics));
    watch(localPreSelectedMetrics, function (value) {
      emit('selection-change', value);
    }, {
      deep: true
    });
    var handleChange = function handleChange(ids) {
      var newMetrics = metrics.value.filter(function (metric) {
        return ids.includes(metric.id);
      });
      localPreSelectedMetrics.value = newMetrics;
    };
    var editMetricDialog = ref({});
    function handleMetricUpsert(id) {
      var dialogState = editMetricDialog.value;
      if (dialogState[id]) {
        dialogState[id] = false;
        delete dialogState[id];
      }
    }
    var itemCount = computed(function () {
      var _metricsResult$value2;
      return ((_metricsResult$value2 = metricsResult.value) === null || _metricsResult$value2 === void 0 ? void 0 : _metricsResult$value2.countMetrics) || 0;
    });
    var searched = ref(false);
    var expanded = ref([]);
    return {
      __sfc: true,
      proxy: proxy,
      props: props,
      emit: emit,
      options: options,
      normalizeArray: normalizeArray,
      defaultAssignedTos: defaultAssignedTos,
      defaultCategoryIds: defaultCategoryIds,
      HIDDEN_SECTION_IDS: HIDDEN_SECTION_IDS,
      explicitSectionFilter: explicitSectionFilter,
      hasExplicitSectionFilter: hasExplicitSectionFilter,
      isRelationshipQuery: isRelationshipQuery,
      isHiddenSection: isHiddenSection,
      input: input,
      isPaiSelection: isPaiSelection,
      isAdditionalPaiSelection: isAdditionalPaiSelection,
      paiAssignedToRestriction: paiAssignedToRestriction,
      variables: variables,
      scopedAssigneeIds: scopedAssigneeIds,
      scopedAssignmentsResult: scopedAssignmentsResult,
      scopedMetricIds: scopedMetricIds,
      accountResult: accountResult,
      account: account,
      sectionVariables: sectionVariables,
      sectionResult: sectionResult,
      onResult: onResult,
      findLeaves: findLeaves,
      metricsResult: metricsResult,
      loading: loading,
      open: open,
      sectionItems: sectionItems,
      openAssignedTo: openAssignedTo,
      assignedToItems: assignedToItems,
      categoryResult: categoryResult,
      onCategoryResult: onCategoryResult,
      openCategories: openCategories,
      findCategoryLeaves: findCategoryLeaves,
      transformCategoryToTreeview: transformCategoryToTreeview,
      categoryItems: categoryItems,
      metrics: metrics,
      showDebugging: showDebugging,
      headers: headers,
      localPreSelectedMetrics: localPreSelectedMetrics,
      handleChange: handleChange,
      editMetricDialog: editMetricDialog,
      handleMetricUpsert: handleMetricUpsert,
      itemCount: itemCount,
      searched: searched,
      expanded: expanded,
      TypeMetricAssignedTo: TypeMetricAssignedTo
    };
  }
});